// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3VbhQ","tab":"Tabs_tab__2zyK9","tabActive":"Tabs_tabActive__Ir3wi"};